<template>
  <div class="custom-table" id="dynamic-products-id">
    <breadcrumb-base :breadcrumb="breadcrumb" :title="'DynamicProducts'">
      <template v-slot:right-end>
        <div class="vx-row">
          <vs-button class="alpha-clear" v-if="selectedAlpha" color="warning" type="flat"
                     icon-pack="feather" icon="icon-x" size="small"
                     @click="clearSelectedAlpha()"></vs-button>
          <vs-pagination-modified v-model="selectedAlphaCurrentX" :total="26" :max="26"
                                  v-on:change="pageChanged"></vs-pagination-modified>
        </div>
      </template>
    </breadcrumb-base>
    <transition name="fade">
      <div class="py-6 flex w-full bg-img" v-if="errorFetching">
        <div
          class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
          <img src="@/assets/images/pages/svg_error.svg" :alt="$t('NoData')"
               class="mx-auto mb-4 max-w-full">
          <h1 class="sm:mx-0 mx-4 mb-12 text-3xl">{{$t('ErrorData')}}</h1>
        </div>
      </div>
    </transition>
    <vs-table-modified v-show="!errorFetching" ref="table"
                       :data="dynamicProducts"
                       :max-items="50"
    >
      <template slot="header">
        <vs-row>
          <vs-spacer></vs-spacer>

          <div
            class="con-input-search vs-table--search pr-5">
            <vs-input
              class="input-search"
              @input="searchDebounce"
              v-model="searchText"
              type="text"
              icon-no-border icon="search" />
          </div>
          <div>
            <vs-button @click="onSubmitProducts" type="filled" >{{ $t('Submit') + '  ' + (selectedConfigs.length > 0 ? selectedConfigs.length : '') }}
            </vs-button>
          </div>
        </vs-row>
      </template>

      <template slot="thead">
        <vs-th></vs-th>
        <vs-th >{{$t('ProductName')}}</vs-th>
        <vs-th >{{$t('Image')}}</vs-th>
        <vs-th>{{$t('Denomination')}}</vs-th>
        <vs-th >{{$t('SoftApiCard')}}</vs-th>
        <vs-th >{{$t('PJTelesoftAPI')}}</vs-th>
        <vs-th >{{$t('Priority')}}</vs-th>
      </template>


      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="tr.id" v-for="(tr, indextr) in data">

          <vs-td>
            <vs-checkbox v-model="dummyChecks[tr.product_configuration_id]" @input="onProductChecked" :vs-value="tr.product_configuration_id.toString()"></vs-checkbox>
          </vs-td>

          <vs-td>
            <p class="" style="font-weight: bold;">{{ tr.product_name}}</p>
          </vs-td>
          <vs-td>
            <img :src="tr.product_image" :alt="tr.product_name" class="product-image" />
          </vs-td>

          <vs-td>
            <p class="" style="font-weight: bold;">{{ tr.product_configuration_value | germanNumberFormat}}</p>
          </vs-td>

          <vs-td >
            <vs-input class="vs-inputx inputx"
                      :placeholder="$t('SoftApiCard')"
                      v-model="updatedCardsNames[tr.product_configuration_id]" readonly
                      @click="onSoftCardClicked($event, tr.product_configuration_id)"/>

            <vs-button class="alpha-clear"
                       v-if="updatedCardsNames[tr.product_configuration_id] && checkIsChecked(tr.product_configuration_id)"
                       color="danger" type="flat"
                       icon-pack="feather" icon="icon-x" size="small"
                       @click="onSoftCardCleared()"></vs-button>
          </vs-td>
          <vs-td >
            <vs-input class="vs-inputx inputx"
                      :placeholder="$t('PJTelesoftAPI')"
                      v-model="pjUpdatedCardsNames[tr.product_configuration_id]" readonly
                      @click="onPJCardClicked($event, tr.product_configuration_id)"/>

            <vs-button class="alpha-clear"
                       v-if="pjUpdatedCardsNames[tr.product_configuration_id] && checkIsChecked(tr.product_configuration_id)"
                       color="danger" type="flat"
                       icon-pack="feather" icon="icon-x" size="small"
                       @click="onPJCardCleared()"></vs-button>
          </vs-td>

<!--          <vs-td>-->
<!--            <vs-input :disabled="!checkIsChecked(tr.product_configuration_id)" class="vs-inputx inputx" :placeholder="$t('EPayApiName')" v-model="updatedCardsEPayName[tr.product_configuration_id]" @input="onEPayApiNameEdited($event, tr.product_configuration_id)"/>-->
<!--          </vs-td>-->
          <vs-td>
            <vs-select
              style="width: 140px;"
              autocomplete
              label=""
              v-model="updatedPriority[tr.product_configuration_id]"
              :disabled="!checkIsChecked(tr.product_configuration_id)"
            >
              <vs-select-item :value="-1" text="None" />
              <vs-select-item :value="0" text="BELTEN" />
              <vs-select-item :value="2" text="PJ Telesoft API" />
            </vs-select>
          </vs-td>

        </vs-tr>
        </tbody>
      </template>


      <template slot="footer">
      </template>
      <template slot="footer-left">
        <div class="flex">
          <vs-new-pagination :total="vTotalPages" v-model="currentPage" v-on:change="listPageChanged">
          </vs-new-pagination>
        </div>
      </template>
    </vs-table-modified>


    <vx-modal v-if="selectedConfigForSoftCard">
      <template slot="body">
        <div>
          <div class="mx-6 vs-row">
          <div class="bg-white flex items-center rounded-full shadow-xl">
            <input v-model="softApiSearchText" class="text-xl rounded-full w-full py-4 px-6 text-gray-700 leading-tight focus:outline-none" id="search" type="text" :placeholder="$t('Search')">
          </div>
          <div class="p-2"></div>
        </div>
          <div class="" style="max-height: 500px;overflow-y: scroll;">

            <div class="grid grid-cols-3 grid-rows-3 gap-4 m-6">
              <template v-for="(card, index) in softApiCards">
                <vx-card class="cursor-pointer" :title="card.cardname" :subtitle="card.denomination | germanNumberFormat" @click="onSoftCardSelected(card)">
                  <p><span><strong>{{ $t('Profit') }} : </strong></span> <small>{{(card.denomination - card.pprice) | germanNumberFormat}}</small></p>
                </vx-card>
              </template>
            </div>
          </div>
          <div class="vx-row mx-12">
            <vs-spacer></vs-spacer>
            <vs-button class="mt-3" color="danger" type="border" @click="onSoftCardSelected(null)">Close</vs-button>
          </div>
        </div>
      </template>
    </vx-modal>
    <vx-modal v-if="selectedConfigForPJApi">
      <template slot="body">
        <div>
          <div class="mx-6 vs-row">
          <div class="bg-white flex items-center rounded-full shadow-xl">
            <input v-model="pjApiSearchText" class="text-xl rounded-full w-full py-4 px-6 text-gray-700 leading-tight focus:outline-none" type="text" :placeholder="$t('Search')">
          </div>
          <div class="p-2"></div>
        </div>
          <div class="" style="max-height: 500px;overflow-y: scroll;">
            <div class="grid grid-cols-3 grid-rows-3 gap-4 m-6">
              <template v-for="(card, index) in pjApiCards">
                <template v-for="(denomination, dindex) in card.product_denominations">
                  <vx-card class="cursor-pointer pb-3" :title="card.product_name" :subtitle="denomination.value | germanNumberFormat" @click="onPJCardSelected(card, denomination)">
                  </vx-card>
                </template>
              </template>
            </div>
          </div>
          <div class="vx-row mx-12">
            <vs-spacer></vs-spacer>
            <vs-button class="mt-3" color="danger" type="border" @click="onPJCardSelected(null)">Close</vs-button>
          </div>
        </div>
      </template>
    </vx-modal>
  </div>
</template>

<script>
import VxModal from '@/layouts/components/custom/VxModal'

export default {
  name: 'dynamic_products',
  components: {
    VxModal,
  },
  data() {
    return {
      currentPage: 1,
      dummyChecks: {},
      isMounted: false,
      errorFetching: false,
      updatedCards: {},
      pjUpdatedCards: {},
      selectedConfigs: [],
      updatedCardsNames: {},
      pjUpdatedCardsNames: {},
      updatedPriority: {},
      selectedConfigForSoftCard: null,
      selectedConfigForPJApi: null,
      softApiSearchText: null,
      pjApiSearchText: null,
      searchText: '',
      selectedAlpha: null,
      selectedAlphaCurrentX: 1,
      breadcrumb: [
        { title: 'Home', i18n: 'Home', url: '/' },
        { title: 'Dynamic Products', i18n: 'DynamicProducts', active: true },
      ],
      selectedProductType: null,
      productTypes: [
        {
          'name': 'Cash Cards',
          'key': 'cash card',
        }
      ],
    }
  },
  computed: {
    dynamicProducts() {
      return this.$store.state.dynamicProducts.dynamicProducts
    },
    dynamicProductsRaw() {
      return this.$store.state.dynamicProducts.dynamicProductsRaw
    },
    softApiCards() {
      if (!this.softApiSearchText) return this.$store.state.dynamicProducts.softApiCards
      return this.$store.state.dynamicProducts.softApiCards.filter((p) => p.cardname.toLowerCase().startsWith(this.softApiSearchText.toLowerCase()))
    },
    pjApiCards() {
      if (!this.pjApiSearchText) return this.$store.state.dynamicProducts.pjApiCards
      return this.$store.state.dynamicProducts.pjApiCards.filter((p) => p.product_name.toLowerCase().startsWith(this.pjApiSearchText.toLowerCase()))
    },
    vPage() {
      return this.$store.state.dynamicProducts.vPage
    },
    vLimit() {
      return this.$store.state.dynamicProducts.limit
    },
    vTotalPages() {
      return this.$store.state.dynamicProducts.vTotalPages
    },
  },
  methods: {

    clearSelectedAlpha() {
      this.selectedAlpha = null
      this.selectedAlphaCurrentX = 1

      this.searchText = ''
      this.fetchDynamicProducts('0', this.searchText)
    },
    pageChanged(newIndex) {
      if (isNaN(newIndex)) {
        this.selectedAlpha = newIndex
        this.selectedAlphaCurrentX = newIndex
        this.searchText = this.selectedAlphaCurrentX
      }
      this.fetchDynamicProducts('0', this.searchText)
    },
    onProductTypeSelected() {
      this.fetchDynamicProducts()
    },
    onSubmitProducts() {
      if (this.selectedConfigs.length === 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Error',
          text: 'Please select at-least one product',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        })
        return
      }
      const d = []
      this.selectedConfigs.forEach((p) => {
        const softId = this.updatedCards[p]
        const softName = this.updatedCardsNames[p]
        const pjName = this.pjUpdatedCardsNames[p]
        const pjId = this.pjUpdatedCards[p]

        const priority = this.updatedPriority[p]
        const obj = {
          'product_configuration_id': p, 'soft_api_id': softId,
          'soft_api_name': softName, 'pj_telesoft_api_id': pjId, 'pj_telesoft_api_name': pjName,
        }
        if(priority == -1) {
          obj['remove_priority'] = 1;
        } else {
          obj['priority'] = priority;
        }

        d.push(obj)
      })

      this.$vs.loading()
      this.$store.dispatch('dynamicProducts/updateDynamicProductConfigs', d)
        .then((data) => {
          this.$vs.loading.close()
          this.errorFetching = false
          this.$vs.notify({
            position: 'top-center',
            title: 'Success',
            text: 'Products Updated Successful',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success',
          })
          this.initValues()
          this.updateData()
          this.fetchDynamicProducts()
        })
        .catch((error) => {
          console.error(error)
          this.$vs.loading.close()
          this.errorFetching = true
          this.$vs.notify({
            position: 'top-center',
            title: 'Error',
            text: error.response.data.message || error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
    checkIsChecked(id) {
      return this.selectedConfigs.indexOf(id.toString()) !== -1
    },
    onProductChecked(value) {
      this.selectedConfigs = []
      Object.values(this.dummyChecks).forEach((d) => {
        if (d) this.selectedConfigs.push(d)
      })
    },
    onSoftCardClicked(event, id) {
      if (!this.checkIsChecked(id)) return
      this.selectedConfigForSoftCard = id
    },
    onPJCardClicked(event, id) {
      if (!this.checkIsChecked(id)) return
      this.selectedConfigForPJApi = id
      console.log(this.selectedConfigForPJApi)
    },
    onSoftCardCleared() {
      this.selectedConfigForSoftCard = null
      this.updatedCards = {}
      this.updatedCardsNames = []
    },
    onPJCardCleared() {
      this.selectedConfigForPJApi = null
      this.pjUpdatedCards = {}
      this.pjUpdatedCardsNames = []
    },
    onSoftCardSelected(card) {
      if (card) {
        const obj = { ...this.updatedCards }
        this.updatedCards = {}
        obj[this.selectedConfigForSoftCard] = card.cardid
        this.updatedCards = obj
        this.updatedCardsNames[this.selectedConfigForSoftCard] = `${card.cardname} - ${card.denomination}`
      }
      this.selectedConfigForSoftCard = null
      this.softApiSearchText = ''
    },
    onPJCardSelected(card, denomination) {
      if (card) {
        const obj = { ...this.pjUpdatedCards }
        this.pjUpdatedCards = {}
        obj[this.selectedConfigForPJApi] = denomination.denomination_id
        this.pjUpdatedCards = obj
        this.pjUpdatedCardsNames[this.selectedConfigForPJApi] = `${card.product_name} - ${this.$options.filters.germanNumberFormat(denomination.value)}`
      }
      this.selectedConfigForPJApi = null
      this.pjApiSearchText = ''
    },
    initValues() {
      this.dummyChecks = {}
      this.updatedCards = {}
      this.pjUpdatedCards = {}
      this.updatedCardsNames = {}
      this.pjUpdatedCardsNames = {}
      this.updatedPriority = {}
      this.selectedConfigs = []
    },
    updateData() {
      const softName = {}
      const softCard = {}
      const pjName = {}
      const pjCard = {}
      const upP = {}
      this.dynamicProducts.forEach((p) => {
        if (p.soft_api_name) softName[p.product_configuration_id] = p.soft_api_name
        if (p.soft_api_id) softCard[p.product_configuration_id] = p.soft_api_id
        if (p.pj_telesoft_api_name) pjName[p.product_configuration_id] = p.pj_telesoft_api_name
        if (p.pj_telesoft_api_id) pjCard[p.product_configuration_id] = p.pj_telesoft_api_id
        if (p.priority != null) upP[p.product_configuration_id] = p.priority
        else upP[p.product_configuration_id] = null
      })
      this.updatedCards = softCard
      this.updatedCardsNames = softName
      this.pjUpdatedCards = pjCard
      this.pjUpdatedCardsNames = pjName
      this.updatedPriority = upP
    },
    searchDebounce() {
      clearTimeout(this.interval)
      this.interval = setTimeout(() => {
        this.fetchDynamicProducts('0', this.searchText)
      }, 500)
    },
    listPageChanged(item) {
      this.fetchDynamicProducts(this.currentPage - 1, this.searchText)
    },
    fetchDynamicProducts(page = '0', search = '') {
      this.$vs.loading()
      return this.$store.dispatch('dynamicProducts/fetchDynamicProductConfigs',
        { data: this.selectedProductType, page, search })
        .then((data) => {
          this.$vs.loading.close()
          this.errorFetching = false
          this.updateData()
        })
        .catch((error) => {
          console.error(error)
          this.$vs.loading.close()
          this.errorFetching = true
          this.$vs.notify({
            position: 'top-center',
            title: 'Error',
            text: error.message ? error.message : error.response.data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
  },
  created() {
    this.$vs.loading()
    // this.fetchDynamicProducts()
    this.$store.dispatch('dynamicProducts/fetchSoftApiCards')
      .then((data) => {
        this.$vs.loading.close()
        this.errorFetching = false
      })
      .catch((error) => {
        console.error(error)
        this.$vs.loading.close()
        this.errorFetching = true
        this.$vs.notify({
          position: 'top-center',
          title: 'Error',
          text: error.message ? error.message : error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        })
      })
    this.$store.dispatch('dynamicProducts/fetchPJApiCards')
      .then((data) => {
        this.$vs.loading.close()
        this.errorFetching = false
      })
      .catch((error) => {
        console.error(error)
        this.$vs.loading.close()
        this.errorFetching = true
        this.$vs.notify({
          position: 'top-center',
          title: 'Error',
          text: error.message ? error.message : error.response.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        })
      })
  },
}
</script>

<style lang="scss">
#dynamic-products-id {
  .vs-input--input {
    background-color: #FFFFFF !important;
    opacity: 1 !important;
    font-weight: bold;
  }
  .vs-select--input {
    background-color: #FFFFFF !important;
    opacity: 1 !important;
    font-weight: bold;
  }
  .vs-input--input:disabled {
    background-color: #FFFFFF !important;
    opacity: 1 !important;
    font-weight: bold;
  }
  .vs-select--input:disabled {
    background-color: #FFFFFF !important;
    opacity: 1 !important;
    font-weight: bold;
  }
}
</style>
